module.exports = __webpack_public_path__ + "img/icon-default2.57ffdaa1.png";